export const BLOCKED_TYPES = {
    AMENDMENT: 'AMENDMENT - ICP',
    INVOICE: 'INVOICE - ICP',
    UNBLOCK: 'UNBLOCK',
};
